// Exact Figma export (Lucide, 2px stroke on a 24px grid). Stroke colour is a prop.
function PaywallCreditCard({ dimensions, col = '#fff' }) {
  return `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.9992 9.99977H22.0008M3.99936 4.9992H20.0006C21.1053 4.9992 22.0008 5.89473 22.0008 6.99943V17.0006C22.0008 18.1053 21.1053 19.0008 20.0006 19.0008H3.99936C2.8947 19.0008 1.9992 18.1053 1.9992 17.0006V6.99943C1.9992 5.89473 2.8947 4.9992 3.99936 4.9992Z" stroke="${col}" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `;
}

export default PaywallCreditCard;
